module.exports = "/video-roulette/img/blue-ball.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/video-roulette/img/blue-ball.png
// module id = 2439
// module chunks = 10